// extracted by mini-css-extract-plugin
module.exports = {"container":"Rating_container__ARmfQ","icon":"Rating_icon__2EjV9","type_name":"Rating_type_name__E8Au1"};